import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function Calendar(props: IconProps) {
  return (
    <IconSvg {...props}>
      <path d="M32 30.958c0 .576-.448 1.042-1 1.042H5c-.552 0-1-.466-1-1.042V8a1 1 0 011-1h5V5.5a.5.5 0 011 0V7h14V5.5a.5.5 0 011 0V7h5a1 1 0 011 1v22.958zM31 13H5v18h26V13zm-12.5 3a5.5 5.5 0 110 11 5.5 5.5 0 110-11zm0 1a4.505 4.505 0 00-4.5 4.5 4.5 4.5 0 104.5-4.5zm0 2a.5.5 0 01.5.5v2.25l1.8 1.35a.498.498 0 11-.6.8l-2-1.5a.5.5 0 01-.2-.4v-2.5a.5.5 0 01.5-.5zM31 8H5v4h26V8z"></path>
    </IconSvg>
  );
}
